/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://aocyw6k7ujelzkq6nisoeorvri.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-3qbzus2qsngizmcqk6smejjap4",
    "aws_cloud_logic_custom": [
        {
            "name": "scrape",
            "endpoint": "https://riw8shmfgb.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:6fc84e0b-54fd-4b15-b73f-9626e9b6363f",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_NnNpK8Lkf",
    "aws_user_pools_web_client_id": "6g8nspj0sjmrb1j3n7ueis4uuj",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "stolencycles-brightdata-dev154344-dev",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
